/**
 * API Configuration
 * All API calls route to Supabase Edge Functions
 */

// Supabase Edge Functions URL
export const EDGE_FUNCTIONS_URL = import.meta.env.VITE_SUPABASE_URL
  ? `${import.meta.env.VITE_SUPABASE_URL}/functions/v1`
  : '';

// Legacy export kept for backwards compatibility (BFT hooks reference it)
export const API_BASE_URL = EDGE_FUNCTIONS_URL;

/**
 * Build the full URL for an API request
 * Routes all requests to Supabase Edge Functions
 */
export function buildApiUrl(path: string): string {
  if (!EDGE_FUNCTIONS_URL) {
    console.warn('VITE_SUPABASE_URL not configured, API calls will fail');
    return path;
  }

  // Normalize path - remove /api prefix
  let normalizedPath = path;
  if (normalizedPath.startsWith('/api')) {
    normalizedPath = normalizedPath.slice(4);
  }

  // Ensure path starts with /
  if (!normalizedPath.startsWith('/')) {
    normalizedPath = '/' + normalizedPath;
  }

  return EDGE_FUNCTIONS_URL + normalizedPath;
}

// Legacy exports kept for backwards compatibility
export function isMigratedRoute(_path: string): boolean {
  return true;
}

export function getApiUrl(_path: string): string {
  return EDGE_FUNCTIONS_URL || '';
}
